import { render } from "./HistoryIcon.vue?vue&type=template&id=86a8acfc"
import script from "./HistoryIcon.vue?vue&type=script&lang=js"
export * from "./HistoryIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__